import { useQuery } from "react-query";
import axios from "axios";
import { AdminAnalyticsAndReportsAPI } from "../../../../constants/API";
import { commonHeaders } from "../../../../constants/HeadersAPI";

type CurrentServicesEmployeesType = {
  workPlace: string;
  worker: string;
  accessType: string;
  status: string;
  statusTime: string;
  currentTopic: string;
  workTime: string;
  downTime: string;
};

export const useGetCurrentServicesEmployees = (
  branchQueueId?: number | null,
) => {
  const {
    data: currentServicesEmployeesResp,
    isLoading: isLoadingCurrentServicesEmployees,
    isSuccess: isCurrentServicesEmployeesRecieved,
  } = useQuery(
    ["currentServicesEmployees", branchQueueId ?? null],
    () =>
      axios.get<CurrentServicesEmployeesType[]>(
        `${AdminAnalyticsAndReportsAPI.getCurrentServicesStatusEmployees}${
          branchQueueId ? `?branchQueueId=${branchQueueId}` : ""
        }`,
        commonHeaders(),
      ),
    {
      enabled: branchQueueId != null,
      keepPreviousData: true,
      refetchInterval: 60_000,
      refetchIntervalInBackground: true,
      select: ({ data }) => {
        if (data?.length) {
          return data.map((e) => {
            return {
              workPlace: e.workPlace,
              employer: e.worker,
              role: e.accessType,
              status: e.status,
              statusTime: e.statusTime,
              currentService: e.currentTopic,
              serviceTimeForCurrentService: e.workTime,
              downTime: e.downTime,
            };
          });
        } else {
          return [];
        }
      },
    },
  );

  return {
    currentServicesEmployeesResp,
    isLoadingCurrentServicesEmployees,
    isCurrentServicesEmployeesRecieved,
  };
};
